import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';

import {SocialAccounts} from 'components/UIKit/Types';
import {Icon} from 'components/UIKit';
import styles from './NavSocialLink.scss';

type AnchorElementProps = JSX.IntrinsicElements['a'];

interface NavSocialLinkProps extends AnchorElementProps {
  name: SocialAccounts;
  text: string;
  url: string;
}

export function NavSocialLink({name, text, url, ...restProps}: NavSocialLinkProps) {
  return (
    <li className={classNames(styles.listItem, styles[name])}>
      <a
        className={styles.link}
        target="_blank"
        rel="me noopener noreferrer"
        data-ga-event="Social"
        data-ga-action={name}
        data-ga-label="NavDrawer"
        href={url}
        {...restProps}
      >
        <Icon icon={name} alt={text} size={20} fill="white" />
      </a>
    </li>
  );
}

export default NavSocialLink;
